import { createTheme } from "@mui/material";

export const AppDefaultTheme = createTheme({
  palette: {
    type: 'light',
    primary: {
      light: "#16a3b6",
      main: '#4377bd',
    },
    secondary: {
      main: '#002554',
    },
    tertiary: {
      main: '#002554',
    }
  },
});
